module.exports = __webpack_public_path__ + "static/media/CurrencyRupee.d45d325b.svg";